import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Layout/Navbar';
import Hero from './components/Sections/Hero';
import Services from './components/Sections/Services';
import About from './components/Sections/About';
import TechStack from './components/Sections/TechStack';
import BlogHighlight from './components/Sections/BlogHighlight';
import FAQ from './components/Sections/FAQ';
import Footer from './components/Layout/Footer';
import BlogListing from './components/Blog/BlogListing';
import BlogPost from './components/Blog/BlogPost';
import ServicesPage from './components/Pages/ServicesPage';
import SolutionsPage from './components/Pages/SolutionsPage';
import AboutPage from './components/Pages/AboutPage';
import CalgaryPage from './components/Pages/CalgaryPage';
import VancouverPage from './components/Pages/VancouverPage';
import SEOHead from './components/SEO/SEOHead';

function HomePage() {
  return (
    <>
      <SEOHead
        title="Fractional CTO & Technology Consulting"
        description="North provides fractional CTO services, AI strategy consulting, cloud architecture, and data analytics for startups and mid-market companies. 15+ years of engineering leadership experience."
        path="/"
      />
      <Hero />
      <Services />
      <BlogHighlight />
      <About />
      <FAQ />
      <TechStack />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/calgary" element={<CalgaryPage />} />
          <Route path="/vancouver" element={<VancouverPage />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
